// 키프세이크 카드 → 이미지 추출 + 저장/공유.
// 웹: <a download> / Web Share. 네이티브: 갤러리 저장(Media) / 파일 공유(Filesystem+Share).
import { toPng } from "html-to-image";
import { isNative, nativeSaveImage, nativeShareImage } from "./native";

export async function captureCard(el: HTMLElement): Promise<string> {
  // 폰트가 다 로드된 뒤 캡처해야 글자가 안 깨진다. cacheBust는 @font-face 임베딩을 깨므로 쓰지 않는다.
  try {
    await (document as Document & { fonts?: { ready?: Promise<unknown> } }).fonts?.ready;
  } catch {
    /* fonts API 없음 — 무시 */
  }
  // html-to-image 첫 패스는 임베드 폰트를 놓치는 경우가 있어, 가벼운 워밍업 후 본 캡처한다.
  try {
    await toPng(el, { pixelRatio: 1, backgroundColor: "#0C0D12" });
  } catch {
    /* 워밍업 실패는 무시하고 본 캡처 진행 */
  }
  return toPng(el, { pixelRatio: 2, backgroundColor: "#0C0D12" });
}

function downloadCard(dataUrl: string, name = "hyuh.png"): void {
  const a = document.createElement("a");
  a.href = dataUrl;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
}

/** 저장: 네이티브 → 기기 갤러리. 웹 → 다운로드. 성공 여부 반환. */
export async function saveCard(dataUrl: string): Promise<boolean> {
  if (isNative()) return nativeSaveImage(dataUrl);
  downloadCard(dataUrl);
  return true;
}

function dataUrlToBlob(dataUrl: string): Blob {
  const [head, body] = dataUrl.split(",");
  const mime = head.match(/:(.*?);/)?.[1] ?? "image/png";
  const bin = atob(body);
  const arr = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) arr[i] = bin.charCodeAt(i);
  return new Blob([arr], { type: mime });
}

/** 공유: 네이티브 → 이미지 파일 공유. 웹 → Web Share(파일) → 다운로드 폴백. */
export async function shareCard(dataUrl: string, text = "hyuh.app"): Promise<void> {
  if (isNative()) {
    await nativeShareImage(dataUrl, text);
    return;
  }
  try {
    const blob = dataUrlToBlob(dataUrl);
    const file = new File([blob], "hyuh.png", { type: "image/png" });
    const nav = navigator as Navigator & { canShare?: (d: ShareData) => boolean };
    if (nav.canShare && nav.canShare({ files: [file] })) {
      await navigator.share({ files: [file], text });
      return;
    }
  } catch {
    /* fall through */
  }
  downloadCard(dataUrl);
}
